import { render } from "./SkiLog.vue?vue&type=template&id=0228855a&scoped=true"
import script from "./SkiLog.vue?vue&type=script&lang=js"
export * from "./SkiLog.vue?vue&type=script&lang=js"

import "./SkiLog.vue?vue&type=style&index=0&id=0228855a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0228855a"]])

export default __exports__